import React from 'react';
import { Link, graphql } from 'gatsby';
import { MenuItem, Menu, LinkStyle, ActiveLinkStyle } from 'src/styles/topbar';
import Analytics from 'src/helpers/analytics';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const TopBarMenu = () => {
  const { t } = useTranslation();

  const onAppClick = (name: string) => {
    Analytics.logAppButtonClick(name);
  };

  return (
    <Menu>
      <Link style={LinkStyle} to={'/aboutus'} activeStyle={ActiveLinkStyle}>
        <MenuItem onClick={() => onAppClick('aboutus')}>{t('dropdownMenu.about')}</MenuItem>
      </Link>
      <Link style={LinkStyle} to={'/features'} activeStyle={ActiveLinkStyle}>
        <MenuItem onClick={() => onAppClick('features')}>{t('dropdownMenu.features')}</MenuItem>
      </Link>
      <Link style={LinkStyle} to={'/frequentlyaskedquestions'} activeStyle={ActiveLinkStyle}>
        <MenuItem onClick={() => onAppClick('q&a')}>{t('dropdownMenu.q&a')}</MenuItem>
      </Link>
      <Link style={LinkStyle} to={'/magazine'} partiallyActive={true} activeStyle={ActiveLinkStyle}>
        <MenuItem onClick={() => onAppClick('magazine')}>{t('dropdownMenu.magazine')}</MenuItem>
      </Link>
      <Link style={LinkStyle} to={'/plans'} activeStyle={ActiveLinkStyle}>
        <MenuItem onClick={() => onAppClick('plans')}>{t('dropdownMenu.plans')}</MenuItem>
      </Link>
      {/* <Link style={LinkStyle} to={'/contactus'} activeStyle={ActiveLinkStyle}>
        <MenuItem onClick={() => onAppClick('q&a')}>{t('dropdownMenu.contact')}</MenuItem>
      </Link> */}
    </Menu>
  );
};

export default TopBarMenu;
